import { HStack, Image, Text, VStack } from '@chakra-ui/react';
import CustomButton from '@/components/atoms/CustomButton';
import SvgIconMemberCare from '@/components/atoms/SvgIconMemberCare';
import svgIcons from '@/assets/svg/icons';
import { useNavigate } from '@tanstack/react-router';
import illustrations from '@/assets/img/png/ilustrations';
import { extra, text } from '@/theme/colors/palettes';
import { TSupportTeamCount } from '@/types/User.types';
import useOrganizationMemberCares from '@/hooks/membercare/useOrganizationMemberCares';

const UserSupportTeamSection = ({ supportTeamCounts }: { supportTeamCounts: TSupportTeamCount }) => {
  const navigate = useNavigate();
  const { data: memberCares } = useOrganizationMemberCares();
  const cards = [
    {
      name: 'Therapists', image: illustrations.nurse,
      subtitle: `${supportTeamCounts.therapists} Vetted therapists on platform`,
      description: 'All therapists are vetted and trained to provide support on a variety of topics. Check our therapists directory and find one that best suits your needs.',
      button: 'View MyOmnia Therapists', to: '/directory/provider',
    },
    {
      name: 'MyOmnia Member Care', image: undefined,
      subtitle: memberCares ? `${memberCares.length} Member Care Specialists available` : 'Member Care Specialists available',
      description: 'A dedicated team supporting members’ overall wholeness through guidance, connection, and access to the right resources.',
      button: 'View Member Care Team', to: '/directory/member-care',
    },
    {
      name: 'Peer Support', image: illustrations.headToHead,
      subtitle: `${supportTeamCounts.peerSupports} Members from your team`,
      description: 'You have members in your team that are certified Peer Support Members and they can help you with various issues while being your very close colleagues.',
      button: 'View Peer Support Team', to: '/directory/peer-support',
    },
  ];

  return (
    <HStack width="100%" gap="20px" marginTop="40px" align="stretch" flexDirection={{ base: 'column', lg: 'row' }}>
      {cards.map((card) => (
        <VStack key={card.name} padding="20px" flex="1" minWidth={0} minHeight="265px" boxShadow="0px 8px 40px 0px #0000001A" backgroundColor={extra.white} alignItems="start" justify="space-between" gap="22px" borderRadius="10px">
          <HStack gap="26px" justifyContent="start">
            {card.image ? <Image alt="" height="60px" width="60px" src={card.image} /> : <HStack width="60px" height="60px" justify="center"><SvgIconMemberCare width={54} color="#4E1AEF" leafColor="#FF8500" /></HStack>}
            <VStack gap="6px" alignItems="start">
              <Text variant="loraMedium22" color={text.darkBlue}>{card.name}</Text>
              <Text variant="urbanistBold" color={text.mediumGray}>{card.subtitle}</Text>
            </VStack>
          </HStack>
          <Text variant="urbanistSemiBoldRegular" color={text.mediumBlue}>{card.description}</Text>
          <CustomButton noShadow hoverOpacityDrop label={card.button} iconAfterLabelSvgPath={svgIcons.rightArrow} iconAfterLabelSvgSize={11} iconAfterLabelSvgBoxHeight={14} iconAfterLabelSvgBoxWidth={14} height="54px" width="100%" style={{ padding: 0, borderColor: text.mediumBlue, borderWidth: '2px' }} labelColor={text.mediumBlue} onClick={() => navigate({ to: card.to })} />
        </VStack>
      ))}
    </HStack>
  );
};

export default UserSupportTeamSection;
